module.exports = __webpack_public_path__ + "img/Instagram.78d742c8.png";